import { createBreakpoints } from '../../theme-tools';

/**
 * Breakpoints for responsive design. At a standard 'medium' font size,
 * these sizes equate to:
 *  * sm = 480px
 *  * md = 768px
 *  * mdlg = 880px
 *  * lg = 992px
 *  * xl = 1280px
 *  * 2xl = 1536px
 * If the user has adjusted their font size, the breakpoints will
 * adjust accordingly.
 */
var breakpoints = createBreakpoints({
  sm: '30em',
  md: '48em',
  mdlg: '55em',
  lg: '62em',
  xl: '80em',
  '2xl': '96em'
});
export default breakpoints;